import { HTMLAttributes, ReactNode, forwardRef } from 'react'
import { composeClasses, generateTwClasses } from '@/utils'
import type {
  AlignItemsType,
  FlexDirectionType,
  GapType,
  JustifyContentType
} from '@/interfaces/types'
import { As, AsType } from '../as'

export interface FlexProps extends HTMLAttributes<HTMLDivElement> {
  as?: AsType
  dir?: FlexDirectionType
  gap?: GapType
  children?: ReactNode
  className?: string
  items?: AlignItemsType
  justify?: JustifyContentType
  wFull?: boolean
}

export const Flex = forwardRef<HTMLDivElement, FlexProps>(
  (
    {
      as = 'div',
      dir = 'row',
      children,
      gap,
      className,
      items,
      justify,
      wFull,
      ...restProps
    },
    ref
  ) => {
    const justifyClass = generateTwClasses('justify', justify ?? '')
    const itemsClass = generateTwClasses('items', items ?? '')
    const directionClass = generateTwClasses('flex', dir)

    return (
      <As
        as={as}
        ref={ref}
        className={composeClasses(
          'flex',
          wFull && 'w-full',
          gap,
          directionClass,
          itemsClass,
          justifyClass,
          className
        )}
        {...restProps}
      >
        {children}
      </As>
    )
  }
)

export default Flex
